import { ReactNode } from 'react';
import {
  OpportunityAndRiskCardContainer,
  OpportunityAndRiskCardContent,
  OpportunityAndRiskCardContentEmpty,
  OpportunityAndRiskCardHeader,
} from './styles';
import { CheckCircleOutlined, WarningAmberOutlined } from '@mui/icons-material';
import { Text } from '@/components/atoms/text';
import { useTranslation } from '@/hooks/useTranslation';
import { SafeMarkdown } from '@/components/atoms/markdown/safe';

interface OpportunityAndRiskCardProps {
  variant: 'opportunity' | 'risk';
  children: ReactNode;
  minHeight?: string;
  empty?: boolean;
  gap?: number;
  padding?: string | number;
  isOverhallTab?: boolean;
}

export const OpportunityAndRiskCard = ({
  variant,
  children,
  minHeight,
  empty,
  gap,
  padding,
  isOverhallTab,
}: OpportunityAndRiskCardProps) => {
  const { t } = useTranslation();

  const cardHeader = () => {
    if (variant === 'opportunity') {
      return (
        <>
          <CheckCircleOutlined sx={{ color: 'primary.dark' }} />
          <Text variant="subtitle1" color="primary.dark">
            <SafeMarkdown text={t('label.label.opportunity')} />
          </Text>
        </>
      );
    }

    return (
      <>
        <WarningAmberOutlined sx={{ color: '#663C00' }} />
        <Text variant="subtitle1" color="#663C00">
          <SafeMarkdown text={t('label.label.risk')} />
        </Text>
      </>
    );
  };

  return (
    <OpportunityAndRiskCardContainer>
      <OpportunityAndRiskCardHeader variant={variant}>{cardHeader()}</OpportunityAndRiskCardHeader>

      <OpportunityAndRiskCardContent
        minHeight={minHeight || 'auto'}
        gap={gap}
        empty={empty}
        padding={padding}
      >
        {empty ? (
          <OpportunityAndRiskCardContentEmpty>
            <Text variant="subtitle1" color="text.disabled">
              {isOverhallTab && (
                <SafeMarkdown
                  text={
                    variant === 'opportunity'
                      ? t('label.label.no_opportunity_spotlight')
                      : t('label.label.no_risk_spotlight')
                  }
                />
              )}
              {!isOverhallTab && (
                <SafeMarkdown
                  text={
                    variant === 'opportunity'
                      ? t('label.label.no_opportunity_calculated')
                      : t('label.label.no_risk_calculated')
                  }
                />
              )}
            </Text>
          </OpportunityAndRiskCardContentEmpty>
        ) : (
          children
        )}
      </OpportunityAndRiskCardContent>
    </OpportunityAndRiskCardContainer>
  );
};
